
// SET_TEMPLATE_META
export const SET_TEMPLATE_META = "SET_TEMPLATE_META"
export const SET_USER_DATA = "SET_USER_DATA"